export const GLOBAL_STATE = 'AcademicYears'

export const ACADEMIC_YEAR = 'academicYear'
export const ACADEMIC_YEAR_LIST = 'academicYearList'
export const ACADEMIC_YEAR_ALL = 'academicYearAll'
export const ACADEMIC_YEAR_CREATE = 'academicYearCreate'
